var React = require('react');

function Leaf (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"fill":"currentColor","d":"M416 128H164.65l91.63 160H256a63.79 63.79 0 0 0-55.12 32L54.78 64H416z","className":"fa-secondary","key":0}),React.createElement("path",{"fill":"currentColor","d":"M384 320H256a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32zM160 0H32A32 32 0 0 0 0 32v128a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm448 0H480a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32z","className":"fa-primary","key":1})]));
}

Leaf.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"project-diagram","role":"img","viewBox":"0 0 640 512","className":"svg-inline--fa fa-project-diagram fa-w-20 fa-7x"};

module.exports = Leaf;

Leaf.default = Leaf;
